


































import Vue from 'vue';
import { Component, Emit } from 'vue-property-decorator';
import { State, Mutation } from 'vuex-class';
import { PortalAppHeader } from '@kasasa/portal-components';

@Component({
  components: { PortalAppHeader },
})
export default class App extends Vue {
  @State('user') stateUser: any;

  @Mutation('portalHeaderData') mutationPortalHeaderData: any;

  @Mutation('user') mutationUser: any;

  appTitle: string = 'SaverBot Console';

  errorMessage: string = '';

  user: any;

  @Emit('headerData')
  setHeaderData(data: any) {
    this.mutationPortalHeaderData(data);
  }

  @Emit('user')
  setUser(user: any) {
    this.mutationUser(user);
  }

  @Emit('error')
  showErrorMessage(error: string) {
    this.errorMessage = error;
  }
}
